exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-common {\n  text-align: center;\n  display: block;\n  margin: 30px auto;\n  color: #fff;\n  /* padding: 15px 50px; */\n  border: 3px;\n  border-radius: 10px;\n  width: 100px;\n  height: 40px;\n  background: #A3826C;\n  margin-right: 0.5rem;\n  margin-left: 1rem;\n  cursor: pointer;\n}\n\n.btn-common:hover {\n  transform: scale(0.98);\n  opacity: 0.9;\n}\n\n.btn-common:disabled {\n  background: #cccccc;\n  color: #333;\n  cursor: auto;\n}\n\n.btn-common:disabled:hover {\n  transform: scale(1);\n  opacity: 1;\n}", ""]);

// exports
